import { useState, useEffect } from "react";
import { formatDistanceToNow } from "date-fns";

/**
 * Hook that provides live-updating relative time strings
 * Updates every minute to keep timestamps fresh
 */
export function useRelativeTime(date: Date | string, options?: { addSuffix?: boolean }) {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  const [relativeTime, setRelativeTime] = useState(() => 
    formatDistanceToNow(dateObj, { addSuffix: options?.addSuffix ?? true })
  );

  useEffect(() => {
    // Update immediately
    setRelativeTime(formatDistanceToNow(dateObj, { addSuffix: options?.addSuffix ?? true }));
    
    // Update every 60 seconds
    const interval = setInterval(() => {
      setRelativeTime(formatDistanceToNow(dateObj, { addSuffix: options?.addSuffix ?? true }));
    }, 60000);

    return () => clearInterval(interval);
  }, [dateObj.getTime(), options?.addSuffix]);

  return relativeTime;
}
